module.exports = __webpack_public_path__ + "static/media/money-check-alt.ccc9adf2.svg";